import { render } from "./Roadmap.vue?vue&type=template&id=0de90be8"
import script from "./Roadmap.js?vue&type=script&lang=js"
export * from "./Roadmap.js?vue&type=script&lang=js"

import "./Roadmap.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/jonatan/Documents/Projects/hoptok/onisquadgg.server/VUE/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__